import type React from 'react';
import { Disclosure } from '@headlessui/react';
import LogoPart from '../LogoPart';
import GuestHeaderDesktopLeftPart from './Desktop/LeftPart';
import GuestHeaderDesktopRightPart from './Desktop/RightPart';
import { useTranslation } from 'next-i18next';
import appUtils from '../../../../utils/appUtils';
import MenuButton from '../MenuButton';
import GuestHeaderMobile from './Mobile';

const GuestHeaderNew: React.FC = () => {
  const { i18n } = useTranslation('common');
  const language = i18n.language;
  const currentLocale = appUtils.getLocaleFromLang(language);
  return (
    <Disclosure as="nav" className="bg-white border-b border-light-gray">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex">
                <LogoPart />
                <GuestHeaderDesktopLeftPart />
              </div>
              <div className="flex items-center">
                <GuestHeaderDesktopRightPart currentLocale={currentLocale} />
                <MenuButton open={open} />
              </div>
            </div>
          </div>
          <GuestHeaderMobile currentLocale={currentLocale} />
        </>
      )}
    </Disclosure>
  );
};

export default GuestHeaderNew;
